// extracted by mini-css-extract-plugin
export default {"backgroundWrapper":"Xi7ejlP6zTpFEBrvi_XB","background":"rZKxe8G4Dm6Eq2fJ_MRf","cta":"AByx3vJ8hRmyyf6zATD_"};